var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.82,10.94l-.43-.34-.62.54-.43-.55.5-.55-.35-.45C4.4,8.39,5.32,7.21,6.2,6a2,2,0,0,0,.36-.91A2.59,2.59,0,0,1,9.21,2.77a2.56,2.56,0,0,1,2.44,2.41A2.61,2.61,0,0,1,9.37,7.87a3.75,3.75,0,0,0-1.32.57c1.61,1,.92,2.45,1.07,3.77l-.4,0-.34,0V10.92c0-1.16,0-1.16-.93-2Zm0-.94L7.74,7.81l-1-1.29-2.31,3Zm5.79-3.81A1.7,1.7,0,0,0,10.36,4a1.62,1.62,0,0,0-2.11-.21Zm-.73.72L7.51,4.49A1.74,1.74,0,0,0,7.8,6.58,1.73,1.73,0,0,0,9.93,6.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.0f89b4fe4c178d47a31424025458d79b.svg";
export { ForwardRef as ReactComponent };